import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API_ROOT } from "../services/apiClient";

const shouldTrack = (path) => {
  if (!path) return false;
  if (path.startsWith("/admin")) return false;
  return true;
};

export default function AnalyticsTracker() {
  const loc = useLocation();
  const last = useRef("");
  const visitorIdRef = useRef("");

  useEffect(() => {
    try {
      const key = "visitorId";
      const existing = localStorage.getItem(key);
      if (existing) {
        visitorIdRef.current = existing;
        return;
      }
      // lightweight uuid-ish
      const id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}-${Math.random()
        .toString(36)
        .slice(2, 10)}`;
      localStorage.setItem(key, id);
      visitorIdRef.current = id;
    } catch {
      visitorIdRef.current = "";
    }
  }, []);

  useEffect(() => {
    const path = `${loc.pathname || ""}${loc.search || ""}`;
    if (!shouldTrack(path)) return;
    if (last.current === path) return;
    last.current = path;
    const body = {
      path,
      visitorId: visitorIdRef.current || undefined,
      referrer: typeof document !== "undefined" ? document.referrer || "" : "",
    };
    fetch(`${API_ROOT}/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).catch(() => {});
  }, [loc.pathname, loc.search]);

  return null;
}

